import { sha256 } from "js-sha256";
import { js_utils } from "./frfr-js-utils";
import { json_utils } from "./frfr-json-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-easy69-utils.js/changes_id2026-04-24r1/';


// FRFR UNDER CONSTRUCTION FRFR TODO
/* 
FrFr FRIENDLY FRAMEWORK
frfr-easy69-utils
Version ID: (look at frfr_lib_changes_id)
by 
// Please describe here if you customized this file
*/


// export const script69_utils_v1 = {};
// export class Script69Utils_v1 {
// export class Script69Func_v1 {
// export class Func69_v1 {

export class Easy69_v1 {

  // ----- 'is' methods alphabetical order

  static is_array = (arr) => {
    return js_utils.is_array(arr);
  }

  static is_bool = (x) => {
    return js_utils.is_bool(x);
  }

  static is_string = (x) => {
    return js_utils.is_string(x);
  }

  static is_string_not_empty = (x) => {
    return js_utils.is_string_not_empty(x);
  }

  static is_value_in_array = (val, arr) => {
    return js_utils.is_value_in_array(val, arr);
  };


  // ----- 'fix' methods

  static fix_always_arr = (arr, limit) => { // ensure Array is always returned
    return js_utils.fix_always_arr(arr, limit);
  };

  // -----

  // TODO
  static arr_clone_shallow = (arr, item) => {
    return [...arr];
  }

  static arr_add_item_dirty = (arr, item) => {
    if (Array.isArray(arr)) {
      arr.push(item);
    }
    return arr;
  }

  static arr_add_item_pure = (arr, item) => {
    return [...arr, item];
  }

  static arr_join(arr, separator = '') {
    return arr.join(separator);
  }

  static arr_slice = (arr, start, end) => {
    return arr.slice(start, end);
  }

  static str_slice = (str, start, end) => {
    return str.slice(start, end);
  }

  static str_starts_with = (haystack, needle) => {
    if (typeof haystack !== 'string' || typeof needle !== 'string') {
      return false;
    }
    return haystack.startsWith(needle);
  }

  // TODO ***
  // UNTESTED
  // script69_utils_v1.foreach = (arr, fn) => {
  static foreach = (arr, fn) => {
    if (Array.isArray(arr)) {
      arr.forEach(fn);
    }
  }

  // ----- other methods mostly alphabetical order

  static base64url_encode = (str) => {
    /*
    The warnings about btoa() and atob() are typically NOT deprecation warnings—these functions remain standard in browsers and Node.js 20+. They're likely linter warnings (ESLint, JSHint) or IDE notices about Unicode limitations or legacy status.
    */
    return btoa(str)
      .replace(/\+/g, '-')    // + → -
      .replace(/\//g, '_')    // / → _
      .replace(/=/g, '');     // Remove padding
  }

  static base64url_decode = (str) => {
    return atob(str
      .replace(/-/g, '+')     // - → +
      .replace(/_/g, '/')     // _ → /
      .padEnd(str.length + (4 - str.length % 4) % 4, '='));
  }

  static decode_if_json = (raw) => {
    return json_utils.decode_if_json(raw);
  }

  static sha256 = (str) => {
    const data_digest = sha256(str);
    return data_digest;
  }

  static sort_advanced = (arr, val_extractor, asc = true, presorted_vals) => {
    /*
    IMPORTANT: For compatibility with php version of same function, regardless of whether this function is pure or not, you must receive sorted array thet this function will return.
    For example:
    sorted_arr = Easy69_v1.sort_advanced(arr_to_be_sorted, null, true, null);
    */
    return js_utils.sort_advanced(arr, val_extractor, asc, presorted_vals);
  }
}

